/*
 * Do not change this file.
 */
import { parseCheck } from "@/helpers/utils.js";
import sb351Data from "@/data/sb351.json";
const datastore = {
  namespaced: true,
  state: {
    entryLoaded: false,
    entriesLoaded: false,
    entry: "", // Active user datastore value
    entries: [] // Every user's datastore
  },
  mutations: {
    SET_ENTRY(state, entry) {
      state.entryLoaded = true;
      state.entry = entry;
    },
    SET_ENTRIES(state, entries) {
      state.entriesLoaded = true;
      state.entries = entries;
    }
  },
  actions: {
    setEntry({ commit }, entry) {
      commit("SET_ENTRY", entry);
    },
    setEntries({ commit }, entries) {
      commit("SET_ENTRIES", entries);
    }
  },
  getters: {
    getEntry(state) {
      let entry = parseCheck(state.entry);

      return entry;
    },
    getAllEntries(state) {
      return state.entries;
    },
    getEntries(state) {
      /*
       * Remove entries that have no value
       */
      let entries = state.entries.filter((entry) => entry.value !== "");

      /*
       * This assumes the datastore value is an object,
       * stored as a JSON string and needs to be parsed
       * before it can be used.
       */
      entries = entries.map((entry) => {
        return parseCheck(entry.value);
      });

      entries = entries.map((entry) => {
        entry.codes =
          entry.codes.filter(
            (code) => code.tsLastUpdated > 1767130027 // dec 30, 2025
          ) || [];
        return entry;
      });

      //entries = entries.filter((entry) => entry.codes.length > 0);

      return entries;
    },
    getAdminEntries(state) {
      /*
       * Remove entries that have no value
       */
      let entries = state.entries.filter((entry) => entry.value !== "");

      /*
       * This assumes the datastore value is an object,
       * stored as a JSON string and needs to be parsed
       * before it can be used.
       */
      entries = entries.map((entry) => {
        /*
         * If the value has not been updated, then use the creation date
         */
        // eslint-disable-next-line
        if (entry.tsUpdated == "") {
          entry.tsUpdated = entry.tsCreated;
        }

        let value = parseCheck(entry.value);

        value.codes =
          value.codes.filter(
            (code) => code.tsLastUpdated > 1767130027 // dec 30, 2025
          ) || [];

        /*
         * Make a human-readable timestamp, localized to OSU
         */
        let date = new Date(entry.tsUpdated * 1000);
        let tsUpdatedLabel = date.toLocaleString("en-US", {
          timeZone: "America/Los_Angeles"
        });
        tsUpdatedLabel = tsUpdatedLabel.replace(",", "");

        value.codes =
          value.codes.filter(
            (code) => code.tsLastUpdated > 1767130027 // dec 30, 2025
          ) || [];

        /*
         * Create a new, smaller object for the admin report
         */
        return {
          value: value,
          fullname: entry.fullname,
          onid: entry.onid,
          codesCount: value.codes.length,
          tsUpdated: entry.tsUpdated,
          tsUpdatedLabel: tsUpdatedLabel
        };
      });

      //entries = entries.filter((entry) => entry.codesCount > 0);
      entries = entries.filter((entry) => entry.tsUpdated > 1767130027);

      entries = entries.filter((entry) => entry.value.groupId !== "admin");

      if (
        import.meta.env.VITE_SEGMENT_KEY &&
        import.meta.env.VITE_SEGMENT_KEY === "sb351"
      ) {
        //console.log
        entries = entries.filter((entry) =>
          sb351Data.includes(entry.value.userId)
        );
      } else {
        entries = entries.filter(
          (entry) => !sb351Data.includes(entry.value.userId)
        );
      }

      return entries;
    }
  }
};

export default datastore;
